const ToastNotificationActionTypes = {
  VIEW_DEVICE_LIST: 'VIEW_DEVICE_LIST',
  UNDO_REMOVED_DEVICE: 'UNDO_REMOVED_DEVICE',
  UNDO_REMOVED_DEVICE_LIST: 'UNDO_REMOVED_DEVICE_LIST',
  UNDO_REMOVED_FILTER_SET: 'UNDO_REMOVED_FILTER_SET',
  UNDO_REMOVED_CHART_SET: 'UNDO_REMOVED_CHART_SET',
  VIEW_SW_UPDATE_PROGRESS: 'VIEW_SW_UPDATE_PROGRESS'
};

export default ToastNotificationActionTypes;
